module.exports = __webpack_public_path__ + "static/img/hslogo.f236476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hslogo.png
// module id = 6hg1
// module chunks = 1